import { render, staticRenderFns } from "./assignStaff.vue?vue&type=template&id=13a90d52&scoped=true&"
import script from "./assignStaff.vue?vue&type=script&lang=js&"
export * from "./assignStaff.vue?vue&type=script&lang=js&"
import style0 from "./assignStaff.vue?vue&type=style&index=0&id=13a90d52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a90d52",
  null
  
)

export default component.exports